import { render, staticRenderFns } from "./index_swiper.vue?vue&type=template&id=54c61fce&scoped=true"
import script from "./index_swiper.vue?vue&type=script&lang=js"
export * from "./index_swiper.vue?vue&type=script&lang=js"
import style0 from "./index_swiper.vue?vue&type=style&index=0&id=54c61fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c61fce",
  null
  
)

export default component.exports